import { NavLink, Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useAuth } from "shared/contexts/Auth/AuthContext";
import styles from "./AdministracaoV2Layout.module.scss";

export const AdministracaoV2Layout = () => {
  const navigate = useNavigate();
  const { isVendedor, setPerfilAtivo, logout } = useAuth();

  function acessarCliente() {
    setPerfilAtivo("comprador");
    navigate("/minhaconta");
  }

  function acessarLojista() {
    setPerfilAtivo("vendedor");
    navigate("/minhaslojas");
  }

  async function sair() {
    await logout();
  }

  return (
    <div className={styles.shell}>
      <aside className={styles.sidebar}>
        <div>
          <p className={styles.eyebrow}>MoveLocal</p>
          <h1>Administração</h1>
        </div>

        <nav className={styles.nav} aria-label="Administração V2">
          <NavLink
            to="/admin/v2/variacoes"
            className={({ isActive }) =>
              isActive ? `${styles.link} ${styles.active}` : styles.link
            }
          >
            Variações globais
          </NavLink>
        </nav>

        <div className={styles.contextActions}>
          <p className={styles.contextTitle}>Trocar acesso</p>
          <button type="button" onClick={acessarCliente}>
            Acesso Cliente
          </button>
          {isVendedor && (
            <button type="button" onClick={acessarLojista}>
              Acesso Lojista
            </button>
          )}
        </div>

        <button
          type="button"
          className={styles.logoutButton}
          onClick={() => void sair()}
        >
          Sair da conta
        </button>
      </aside>

      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};
